import React from 'react';
import { AppStateUser } from '../../../client/providers/AppProvider';
import { SelectedConversationContentFragment } from '../../../generated/spin-graphql';
import { SelectedConversationContent } from './SelectedConversationContent';
import { gql } from '@urql/core';
import { InitialConversationContent, InitialMessageContent } from './InitialConversationContent';
import { useRouter } from 'next/router';

type Props = {
    user: AppStateUser;
    onBackClicked: () => void;
    selectedConversation?: SelectedConversationContentFragment[];
    initialMessageContent?: InitialMessageContent;
    searchActive: boolean;
    adminMessages: SelectedConversationContentFragment[];
};

gql`
    fragment ConversationContainer on espin_message {
        ...SelectedConversationContent
    }
`;

export const ConversationContainer: React.FC<Props> = ({
    user,
    onBackClicked,
    selectedConversation,
    initialMessageContent,
    searchActive,
    adminMessages,
}) => {
    const router = useRouter();

    return (
        <div
            className={`conversation-container${
                selectedConversation || !!initialMessageContent || router.query.show_admin_messages === 'true'
                    ? ' has-conversation'
                    : ''
            }`}
        >
            {(selectedConversation && selectedConversation.length > 0) ||
            (adminMessages.length > 0 && router.query.show_admin_messages === 'true') ? (
                <SelectedConversationContent
                    user={user}
                    onBackClicked={onBackClicked}
                    selectedConversation={
                        !!router.query.show_admin_messages && adminMessages.length > 0
                            ? adminMessages
                            : selectedConversation
                    }
                    adminMessages={adminMessages}
                />
            ) : (
                (!!initialMessageContent && !searchActive && (
                    <InitialConversationContent
                        user={user}
                        onBackClicked={onBackClicked}
                        initialMessageContent={initialMessageContent}
                    />
                )) || (
                    <div className="no-conversation-selected-container">
                        <h2 className="title">{'No conversation selected'}</h2>
                        <p className="subtitle">Choose one from your conversation list.</p>
                    </div>
                )
            )}
        </div>
    );
};
